import React from "react";
import ProfileData from "./ProfileData/ProfileData";
import PaymentMethods from "./PaymentMethods/PaymentMethods";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";

import "./Profile.sass";

function Profile() {
  return (
    <article className="profile">
      <div className="section-title">
        <h3>My Profile</h3>
      </div>
      <ErrorBoundary
        classWrapper="payment-section__error"
        classText="payment-section__error-text"
      >
        <ProfileData />
      </ErrorBoundary>
      <PaymentMethods />
    </article>
  );
}
export default Profile;
